import React, {useState} from 'react'
import {CsvImportWizard} from './CsvImportWizard'
import {IMPORT_TYPES, IMPORT_TYPE_KEYS} from './importConfig'
import './DataImport.scss'

/**
 * The "Data Import" section of CRM Next Settings.
 *
 * One shared wizard, two configurations. Remounted on type switch (via `key`)
 * so changing Leads/Clients starts from a clean upload rather than carrying a
 * mapping built against the other schema.
 */
export const DataImport = () => {
    const [type, setType] = useState('leads')
    const config = IMPORT_TYPES[type]

    return (
        <div className="data-import">
            <div className="field-label">Data Import</div>
            <div className="field-help">
                Bring leads and clients in from a spreadsheet exported from another system.
            </div>

            <div className="seg" role="tablist" aria-label="Import type">
                {IMPORT_TYPE_KEYS.map((key) => (
                    <div
                        key={key}
                        role="tab"
                        tabIndex={0}
                        aria-selected={type === key}
                        className={`seg-opt${type === key ? ' active' : ''}`}
                        onClick={() => setType(key)}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setType(key) } }}
                    >
                        {IMPORT_TYPES[key].label}
                    </div>
                ))}
            </div>

            <CsvImportWizard key={type} config={config} />
        </div>
    )
}
